import Carousel from "@/components/ui/carousel/carousel";
import Section from "@/components/ui/section";
import Image from "next/image";
import React from "react";
import { SwiperSlide } from "swiper/react";
import { InstagramEmbed } from "react-social-media-embed";

export default function ChalkTV() {
  const data = [
    {
      link: "https://www.instagram.com/reel/DBVN_npykcE/?igsh=MTNkMHp4Y3VzMzFydQ==",
    },
    {
      link: "https://www.instagram.com/reel/DBIvdA-y2By/?igsh=MW9uZjdrMGR1ZTBhMw==",
    },
    {
      link: "https://www.instagram.com/reel/DA8OwdtyHdz/?igsh=OGIxOGl1eW55ZDl0",
    },
  ];
  const breakpoints = {
    1280: {
      slidesPerView: 3,
      spaceBetween: 20,
      // slidesOffsetBefore: 32,
      // slidesOffsetAfter: 32,
    },
    991: {
      slidesPerView: 2,
      spaceBetween: 20,
      // slidesOffsetBefore: 32,
      // slidesOffsetAfter: 32,
    },
    // when window width is >= 768px
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
      // slidesOffsetBefore: 32,
      // slidesOffsetAfter: 32,
    },
    320: {
      slidesPerView: 1,
      spaceBetween: 15,
      // slidesOffsetBefore: 16,
      // slidesOffsetAfter: 16,
    },
  };
  return (
    <>
      <Section className="bg-beige z-[10]">
        <div className="text-[#676665] text-left w-full flex flex-col justify-center items-center gap-1">
          <h2 className="font-havletica font-light text-darkGrey text-center">
            Chalk TV
          </h2>
        </div>

        <div className="w-full bg-beige z-[10] overflow-hidden">
          <Carousel
            slidesPerView={3}
            spaceBetween={20}
            loop={false}
            className="chalkTv w-full my-8"
            breakpoints={breakpoints}
            navigation={true}
            mousewheel={{
              forceToAxis: true,
              sensitivity: 1,
              releaseOnEdges: true,
            }}
            freeMode={true}
            // pagination={false}
            showNavAbove={true}
            title=""
            inline={false}
            // title="Our Values"
          >
            {data?.map((post, key) => (
              <SwiperSlide key={"Insta" + key}>
                <InstaEmbed link={post?.link} />
              </SwiperSlide>
            ))}
          </Carousel>
        </div>
      </Section>
    </>
  );
}
const InstaEmbed = ({ link }) => {
  return (
    <div className="w-full h-auto">
      <InstagramEmbed url={link} />
    </div>
  );
};
